import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, ChevronRightIcon, EllipsisIcon } from "lucide-react";
import Icon from "./icon";
import cn from "@/utils/cn";
type PaginationProps = {
  page: number;
  pageCount: number;
  setPage: (page: number) => void;
  buttonCount?: number;
  variant?: "default" | "glued";
};
export default function TablePagination(t0) {
  const $ = _c(75);
  const {
    page,
    pageCount,
    setPage,
    buttonCount: t1,
    variant: t2
  } = t0;
  const buttonCount = t1 === undefined ? 7 : t1;
  const variant = t2 === undefined ? "default" : t2;
  let offset;
  if ($[0] !== buttonCount || $[1] !== page || $[2] !== pageCount) {
    offset = 1;
    let t3;
    if ($[4] !== buttonCount || $[5] !== page) {
      t3 = Math.round(page - buttonCount / 2);
      $[4] = buttonCount;
      $[5] = page;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    offset = Math.max(t3, 1);
    offset = Math.min(offset, pageCount - buttonCount + 1);
    offset = Math.max(offset, 1);
    $[0] = buttonCount;
    $[1] = page;
    $[2] = pageCount;
    $[3] = offset;
  } else {
    offset = $[3];
  }
  const t3 = variant === "default" && "p-2.5";
  let t4;
  if ($[7] !== t3) {
    t4 = cn("flex -space-x-px justify-center text-neutral-300", t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = page === 1;
  let t6;
  if ($[9] !== page || $[10] !== setPage) {
    t6 = () => setPage(page - 1);
    $[9] = page;
    $[10] = setPage;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = page !== 1 && "hover:bg-neutral-800 cursor-pointer";
  const t8 = variant === "default" && "border rounded-l";
  const t9 = variant === "glued" && "border-r";
  let t10;
  if ($[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = cn("text-center px-1.5 py-1 hover:text-neutral-100", t7, t8, t9);
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Icon component={ChevronLeftIcon} />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t5 || $[19] !== t6) {
    t12 = <button disabled={t5} onClick={t6} className={t10}>{t11}</button>;
    $[17] = t10;
    $[18] = t5;
    $[19] = t6;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = page === 1;
  let t14;
  if ($[21] !== setPage) {
    t14 = () => setPage(1);
    $[21] = setPage;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = page === 1 ? "bg-neutral-900" : "cursor-pointer hover:bg-neutral-800";
  const t16 = variant === "default" && "border";
  const t17 = variant === "glued" && "border-x border-b";
  let t18;
  if ($[23] !== t15 || $[24] !== t16 || $[25] !== t17) {
    t18 = cn("text-center px-2.5 py-1 hover:text-neutral-100", t15, t16, t17);
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t13 || $[28] !== t14 || $[29] !== t18) {
    t19 = <button disabled={t13} onClick={t14} className={t18}>1</button>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== offset || $[32] !== variant) {
    t20 = offset > 1 && <button disabled={true} className={cn("text-center px-2.5 py-1 text-neutral-500", variant === "default" && "border", variant === "glued" && "border-x border-b")}><Icon component={EllipsisIcon} /></button>;
    $[31] = offset;
    $[32] = variant;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== buttonCount) {
    t21 = Array.from({
      length: buttonCount - 2
    });
    $[34] = buttonCount;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== offset || $[37] !== page || $[38] !== pageCount || $[39] !== setPage || $[40] !== t21 || $[41] !== variant) {
    t22 = t21.map((_, i) => i + 1 < pageCount && <button key={i} onClick={() => setPage(offset + i + 1)} className={cn("text-center px-2.5 py-1 hover:text-neutral-100", page === offset + i + 1 ? "bg-neutral-900" : "cursor-pointer hover:bg-neutral-800", variant === "default" && "border", variant === "glued" && "border-x border-b")}>{offset + i + 1}</button>);
    $[36] = offset;
    $[37] = page;
    $[38] = pageCount;
    $[39] = setPage;
    $[40] = t21;
    $[41] = variant;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== buttonCount || $[44] !== offset || $[45] !== pageCount || $[46] !== variant) {
    t23 = offset + buttonCount < pageCount + 1 && <button disabled={true} className={cn("text-center px-2.5 py-1 text-neutral-500", variant === "default" && "border", variant === "glued" && "border-x border-b")}><Icon component={EllipsisIcon} /></button>;
    $[43] = buttonCount;
    $[44] = offset;
    $[45] = pageCount;
    $[46] = variant;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== buttonCount || $[49] !== page || $[50] !== pageCount || $[51] !== setPage || $[52] !== variant) {
    t24 = buttonCount - 1 < pageCount && <button disabled={page >= pageCount} onClick={() => setPage(pageCount)} className={cn("text-center px-2.5 py-1 hover:text-neutral-100", page >= pageCount ? "bg-neutral-900" : "cursor-pointer hover:bg-neutral-800", variant === "default" && "border", variant === "glued" && "border-x border-b")}>{pageCount}</button>;
    $[48] = buttonCount;
    $[49] = page;
    $[50] = pageCount;
    $[51] = setPage;
    $[52] = variant;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  const t25 = page >= pageCount;
  let t26;
  if ($[54] !== page || $[55] !== setPage) {
    t26 = () => setPage(page + 1);
    $[54] = page;
    $[55] = setPage;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  const t27 = page < pageCount && "hover:bg-neutral-800 cursor-pointer";
  const t28 = variant === "default" && "border rounded-r";
  const t29 = variant === "glued" && "border-l";
  let t30;
  if ($[57] !== t27 || $[58] !== t28 || $[59] !== t29) {
    t30 = cn("text-center px-1.5 py-1 hover:text-neutral-100", t27, t28, t29);
    $[57] = t27;
    $[58] = t28;
    $[59] = t29;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Icon component={ChevronRightIcon} />;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t25 || $[63] !== t26 || $[64] !== t30) {
    t32 = <button disabled={t25} onClick={t26} className={t30}>{t31}</button>;
    $[62] = t25;
    $[63] = t26;
    $[64] = t30;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== t12 || $[67] !== t19 || $[68] !== t20 || $[69] !== t22 || $[70] !== t23 || $[71] !== t24 || $[72] !== t32 || $[73] !== t4) {
    t33 = <div className={t4} role="group">{t12}{t19}{t20}{t22}{t23}{t24}{t32}</div>;
    $[66] = t12;
    $[67] = t19;
    $[68] = t20;
    $[69] = t22;
    $[70] = t23;
    $[71] = t24;
    $[72] = t32;
    $[73] = t4;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  return t33;
}